/**
 * DPos
 * API for DPos
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Merchant } from './merchant';


export interface MembershipSetting { 
    createdByName?: string;
    creationTime?: string;
    deleted?: boolean;
    id?: number;
    merchant?: Merchant;
    redemptionPeriodType?: MembershipSetting.RedemptionPeriodTypeEnum;
    settingDescription?: string;
    settingName?: string;
    settingType?: MembershipSetting.SettingTypeEnum;
    settingValue?: number;
    updateTime?: string;
    updatedByName?: string;
}
export namespace MembershipSetting {
    export type RedemptionPeriodTypeEnum = 'DAILY' | 'MONTHLY' | 'WEEKLY' | 'YEARLY';
    export const RedemptionPeriodTypeEnum = {
        Daily: 'DAILY' as RedemptionPeriodTypeEnum,
        Monthly: 'MONTHLY' as RedemptionPeriodTypeEnum,
        Weekly: 'WEEKLY' as RedemptionPeriodTypeEnum,
        Yearly: 'YEARLY' as RedemptionPeriodTypeEnum
    };
    export type SettingTypeEnum = 'DISCOUNT' | 'POINTS';
    export const SettingTypeEnum = {
        Discount: 'DISCOUNT' as SettingTypeEnum,
        Points: 'POINTS' as SettingTypeEnum
    };
}


